import { IStateItem } from '../types/shell';
import { CANADA, USA } from './countries';

export const usStatesList: IStateItem[] = [
  { name: 'Alabama', two_digit_code: 'AL' },
  { name: 'Alaska', two_digit_code: 'AK' },
  { name: 'Arizona', two_digit_code: 'AZ' },
  { name: 'Arkansas', two_digit_code: 'AR' },
  { name: 'California', two_digit_code: 'CA' },
  { name: 'Colorado', two_digit_code: 'CO' },
  { name: 'Connecticut', two_digit_code: 'CT' },
  { name: 'Delaware', two_digit_code: 'DE' },
  { name: 'Florida', two_digit_code: 'FL' },
  { name: 'Georgia', two_digit_code: 'GA' },
  { name: 'Hawaii', two_digit_code: 'HI' },
  { name: 'Idaho', two_digit_code: 'ID' },
  { name: 'Illinois', two_digit_code: 'IL' },
  { name: 'Indiana', two_digit_code: 'IN' },
  { name: 'Iowa', two_digit_code: 'IA' },
  { name: 'Kansas', two_digit_code: 'KS' },
  { name: 'Kentucky', two_digit_code: 'KY' },
  { name: 'Louisiana', two_digit_code: 'LA' },
  { name: 'Maine', two_digit_code: 'ME' },
  { name: 'Maryland', two_digit_code: 'MD' },
  { name: 'Massachusetts', two_digit_code: 'MA' },
  { name: 'Michigan', two_digit_code: 'MI' },
  { name: 'Minnesota', two_digit_code: 'MN' },
  { name: 'Mississippi', two_digit_code: 'MS' },
  { name: 'Missouri', two_digit_code: 'MO' },
  { name: 'Montana', two_digit_code: 'MT' },
  { name: 'Nebraska', two_digit_code: 'NE' },
  { name: 'Nevada', two_digit_code: 'NV' },
  { name: 'New Hampshire', two_digit_code: 'NH' },
  { name: 'New Jersey', two_digit_code: 'NJ' },
  { name: 'New Mexico', two_digit_code: 'NM' },
  { name: 'New York', two_digit_code: 'NY' },
  { name: 'North Carolina', two_digit_code: 'NC' },
  { name: 'North Dakota', two_digit_code: 'ND' },
  { name: 'Ohio', two_digit_code: 'OH' },
  { name: 'Oklahoma', two_digit_code: 'OK' },
  { name: 'Oregon', two_digit_code: 'OR' },
  { name: 'Pennsylvania', two_digit_code: 'PA' },
  { name: 'Rhode Island', two_digit_code: 'RI' },
  { name: 'South Carolina', two_digit_code: 'SC' },
  { name: 'South Dakota', two_digit_code: 'SD' },
  { name: 'Tennessee', two_digit_code: 'TN' },
  { name: 'Texas', two_digit_code: 'TX' },
  { name: 'Utah', two_digit_code: 'UT' },
  { name: 'Vermont', two_digit_code: 'VT' },
  { name: 'Virginia', two_digit_code: 'VA' },
  { name: 'Washington', two_digit_code: 'WA' },
  { name: 'West Virginia', two_digit_code: 'WV' },
  { name: 'Wisconsin', two_digit_code: 'WI' },
  { name: 'Wyoming', two_digit_code: 'WY' },
  { name: 'District of Columbia', two_digit_code: 'DC' },
  { name: 'American Samoa', two_digit_code: 'AS' },
  { name: 'Guam', two_digit_code: 'GU' },
  { name: 'Northern Mariana Islands', two_digit_code: 'MP' },
  { name: 'Puerto Rico', two_digit_code: 'PR' },
  { name: 'Virgin Islands', two_digit_code: 'VI' },
  { name: 'Federated States of Micronesia', two_digit_code: 'FM' },
  { name: 'Marshall Islands', two_digit_code: 'MH' },
  { name: 'Palau', two_digit_code: 'PW' },
  { name: 'Armed Forces Americas', two_digit_code: 'AA' },
  { name: 'Armed Forces Europe', two_digit_code: 'AE' },
  { name: 'Armed Forces Pacific', two_digit_code: 'AP' },
];

export const caProvincesList: IStateItem[] = [
  { name: 'Alberta', two_digit_code: 'AB' },
  { name: 'British Columbia', two_digit_code: 'BC' },
  { name: 'Manitoba', two_digit_code: 'MB' },
  { name: 'New Brunswick', two_digit_code: 'NB' },
  { name: 'Newfoundland and Labrador', two_digit_code: 'NL' },
  { name: 'Northwest Territories', two_digit_code: 'NT' },
  { name: 'Nova Scotia', two_digit_code: 'NS' },
  { name: 'Nunavut', two_digit_code: 'NU' },
  { name: 'Ontario', two_digit_code: 'ON' },
  { name: 'Prince Edward Island', two_digit_code: 'PE' },
  { name: 'Quebec', two_digit_code: 'QC' },
  { name: 'Saskatchewan', two_digit_code: 'SK' },
  { name: 'Yukon', two_digit_code: 'YT' },
];

export const STATE_LIST_BY_COUNTRY: Record<string, IStateItem[]> = {
  [USA.two_digit_code]: usStatesList,
  [CANADA.two_digit_code]: caProvincesList,
};

export const STATE_LIST_COUNTRY_CODES: readonly string[] = Object.keys(STATE_LIST_BY_COUNTRY);

const STATE_INVALID_MESSAGE_BY_COUNTRY: Record<string, string> = {
  [USA.two_digit_code]: 'Enter a valid US state',
  [CANADA.two_digit_code]: 'Enter a valid Canadian province or territory',
};

export const getStateInvalidMessage = (country?: string | null): string =>
  STATE_INVALID_MESSAGE_BY_COUNTRY[(country ?? '').trim()] ?? 'Enter a valid state or province';
